import React from 'react'
import { initSentry } from '@konstellation/monitoring/vite';
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { HelmetProvider } from 'react-helmet-async'
import PerformanceOptimizations from './components/PerformanceOptimizations'

initSentry('info-per');

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <PerformanceOptimizations />
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
